import { render, staticRenderFns } from "./Shadows.vue?vue&type=template&id=7099c2e8&"
import script from "./Shadows.vue?vue&type=script&lang=js&"
export * from "./Shadows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports